import { AsyncLocalStorageContextManager } from "@opentelemetry/context-async-hooks";
import { BasicTracerProvider } from "@opentelemetry/sdk-trace-base";
import { serializeSpan } from "@vortex/shared/telemetry";
import { log } from "../logging";
import { patchBluebirdContext } from "./bluebird-patch";
import { createRendererResource } from "./resources";
/**
 * A minimal SpanProcessor that forwards every completed span to the main
 * process via IPC. The main process handles buffering, error detection,
 * and OTLP export via its own RingBufferSpanProcessor.
 */
class ForwardingSpanProcessor {
    onStart(_span, _parentContext) { }
    onEnd(span) {
        window.api.telemetry.forwardSpan(serializeSpan(span));
    }
    forceFlush() {
        return Promise.resolve();
    }
    shutdown() {
        return Promise.resolve();
    }
}
/**
 * Create and register the renderer-process TracerProvider.
 * Call once early in renderer startup, before extensions load.
 */
export const createRendererTelemetryProvider = async () => {
    // Check if preload API is available
    if (typeof window === "undefined" || !window.api?.persist) {
        log("warn", "Preload API not available, telemetry will be disabled");
        return;
    }
    try {
        const version = await window.api.app.getVersion();
        const resource = createRendererResource(version);
        const provider = new BasicTracerProvider({
            resource,
            spanProcessors: [new ForwardingSpanProcessor()],
        });
        provider.register({
            // TODO: Switch to ZoneContextManager when Node.js is removed from renderer
            contextManager: new AsyncLocalStorageContextManager(),
        });
        patchBluebirdContext();
    }
    catch (err) {
        log("error", "Failed to create renderer telemetry provider", {
            error: err,
        });
    }
};
